import React, { useEffect, useState } from 'react';
const comparisonRows = [{
  without: 'Tardes interminables con el celu en la mano',
  with: 'Actividades listas, nene enfocado y aprendiendo'
}, {
  without: 'Berrinche cada vez que se lo sacás',
  with: 'Protocolo anti-berrinche en 5 pasos'
}, {
  without: 'Buscando ideas en Pinterest a las 23hs',
  with: '+500 páginas listas para imprimir hoy'
}, {
  without: 'Videos pasivos sin estimulación real',
  with: 'Letras, números, inglés e inglés jugando'
}, {
  without: 'Sin saber si tu hijo avanza o se atrasa',
  with: 'Actividades por nivel que crecen con él'
}, {
  without: 'Culpa por darle la pantalla para que se calme',
  with: 'Tranquila porque le das lo mejor cada tarde'
}, {
  without: 'Cada viaje o espera = celu obligatorio',
  with: 'Fichas portables para llevar a todos lados'
}, {
  without: 'Sin conexión real madre e hijo',
  with: 'Momentos de calidad que los dos disfrutan'
}, {
  without: 'Tu hijo detrás de una pantalla los mejores años',
  with: 'Aprendiendo, creciendo y conectado con vos'
}];
export function DarkCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 26,
    seconds: 56
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) return {
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="w-full px-4 py-16 sm:py-20 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(248, 250, 252)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-91">
      <div className="mx-auto max-w-4xl text-center" data-id="element-92">
        {/* MARCA */}
        <div className="mb-8 text-2xl sm:text-3xl font-black tracking-[3px] text-orange-500" data-id="element-93">
          🧒 MEGAPACK ANTI PANTALLA™
        </div>

        {/* HEADLINE */}
        <h2 className="text-xl sm:text-3xl font-bold text-gray-900 m-0 mb-3" data-id="element-94">
          Esta tarde tu hijo puede volver a pedir el celu.
        </h2>
        <p className="text-xl sm:text-3xl font-black text-orange-500 m-0 mb-10" data-id="element-95">
          O podés tener todo listo para darle algo mejor desde hoy.
        </p>

        {/* TABLA COMPARATIVA */}
        <div className="mx-auto max-w-2xl mb-12 overflow-hidden rounded-2xl border border-gray-200 text-left" style={{
        backgroundColor: 'rgb(255, 255, 255)'
      }} data-id="element-96">
          <div className="text-center font-bold text-gray-900 border-b border-gray-200 px-4 py-4" style={{
          backgroundColor: 'rgb(243, 244, 246)'
        }} data-id="element-97">
            ¿Cuánto cuesta NO tenerlo?
          </div>

          <div className="grid grid-cols-2 border-b border-gray-200" style={{
          backgroundColor: 'rgb(243, 244, 246)'
        }} data-id="element-98">
            <div className="text-center font-bold text-gray-500 px-4 py-3 text-sm" data-id="element-99">
              SIN MEGAPACK
            </div>
            <div className="text-center font-bold text-orange-500 border-l border-gray-200 px-4 py-3 text-sm" data-id="element-100">
              CON MEGAPACK
            </div>
          </div>

          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-101">
              <div className="px-4 py-3 text-xs sm:text-sm text-gray-500" data-id="element-102">
                ✗ {row.without}
              </div>
              <div className="px-4 py-3 text-xs sm:text-sm font-bold text-gray-900 border-l border-gray-100" style={{
            backgroundColor: 'rgba(249, 115, 22, 0.05)'
          }} data-id="element-103">
                ✅ {row.with}
              </div>
            </div>)}
        </div>

        {/* COUNTDOWN */}
        <div className="mb-4" data-id="element-104">
          <p className="font-bold text-gray-900 m-0 mb-4" data-id="element-105">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-center justify-center gap-0" data-id="element-106">
            <div className="flex flex-col items-center" data-id="element-107">
              <span className="text-5xl sm:text-7xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-108">
                {pad(timeLeft.hours)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-109">
                hs
              </span>
            </div>
            <span className="mb-4 text-5xl sm:text-7xl font-black animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-110">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-111">
              <span className="text-5xl sm:text-7xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-112">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-113">
                min
              </span>
            </div>
            <span className="mb-4 text-5xl sm:text-7xl font-black animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-114">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-115">
              <span className="text-5xl sm:text-7xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-116">
                {pad(timeLeft.seconds)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-117">
                seg
              </span>
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-600 m-0 mb-12" data-id="element-118">
          Después sube{' '}
          <span className="font-bold text-red-500" data-id="element-119">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* CARDS DE PRECIO */}
        <div className="mx-auto max-w-2xl mb-10 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-120">
          {/* OPCIÓN 1 */}
          <div className="flex flex-col rounded-xl p-6 border border-gray-200 shadow-sm" style={{
          backgroundColor: 'rgb(255, 255, 255)'
        }} data-id="element-121">
            <div className="mb-2 text-2xl" data-id="element-122">🧒</div>
            <h3 className="text-base font-black text-gray-900 m-0 mb-1" data-id="element-123">
              MEGAPACK ANTI PANTALLA
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-124">
              6 Tomos + 6 Bonos · +500 páginas · 2 a 7 años
            </p>
            <div className="mt-auto" data-id="element-125">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-126">
                Antes: $49.990 ARS
              </p>
              <p className="text-2xl font-black text-orange-500 m-0 mb-4" data-id="element-127">
                Hoy: $19.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48209465475242:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Megapack Anti Pantalla',
                  content_category: 'Anti Pantalla',
                  value: 19990,
                  currency: 'ARS'
                });
              }
            }} className="block text-white text-center text-sm font-black rounded-lg py-4 no-underline transition-transform active:scale-95 will-change-transform" style={{
              background: 'linear-gradient(135deg, rgb(234, 88, 12) 0%, rgb(249, 115, 22) 50%, rgb(251, 146, 60) 100%)',
              boxShadow: '0 8px 32px rgba(249, 115, 22, 0.4)'
            }} data-id="element-128">
                🛒 QUIERO MI MEGAPACK →
              </a>
            </div>
          </div>

          {/* OPCIÓN 2 — UPSELL */}
          <div className="flex flex-col rounded-xl p-6 border-2 border-orange-500 shadow-sm" style={{
          backgroundColor: 'rgb(255, 247, 237)',
          boxShadow: 'rgba(249, 115, 22, 0.15) 0px 0px 30px 0px'
        }} data-id="element-129">
            <div className="mb-2 text-2xl" data-id="element-130">🏆</div>
            <h3 className="text-base font-black text-orange-500 m-0 mb-1" data-id="element-131">
              MEGAPACK + MÉTODO DESCONECTADO™ ⭐
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-1" data-id="element-132">La más elegida</p>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-133">
              6 Tomos + 6 Bonos + Método Desconectado™
              <br data-id="element-134" />
              (plan 7 días + rutinas + protocolo anti-berrinche)
            </p>
            <div className="mt-auto" data-id="element-135">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-136">
                Antes: $79.990 ARS
              </p>
              <p className="text-3xl font-black text-orange-500 m-0 mb-4" data-id="element-137">
                Hoy: $27.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48209465704618:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Megapack Anti Pantalla + Método Desconectado™',
                  content_category: 'Anti Pantalla',
                  value: 27990,
                  currency: 'ARS'
                });
              }
            }} className="block text-white text-center text-sm font-black rounded-lg py-4 no-underline transition-transform active:scale-95 will-change-transform" style={{
              background: 'linear-gradient(135deg, rgb(234, 88, 12) 0%, rgb(249, 115, 22) 50%, rgb(251, 146, 60) 100%)',
              boxShadow: '0 8px 32px rgba(249, 115, 22, 0.4)'
            }} data-id="element-138">
                🛒 QUIERO EL MEGAPACK + MÉTODO DESCONECTADO™ →
              </a>
            </div>
          </div>
        </div>

        {/* GARANTÍAS */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-600" data-id="element-139">
          <span data-id="element-140">🔒 Pago 100% seguro</span>
          <span data-id="element-141">⚡ Acceso en 5 minutos</span>
          <span data-id="element-142">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-143">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
      </div>
    </section>;
}